import i18n from 'i18n/config'
import { RepaymentMethods } from 'share/enums/payment'
import { ApplicationProgramCode } from 'share/types'
import { numberWithSpaces } from 'utils'
import * as yup from 'yup'

const PROGRAM_CODES = ['OWN_PROGRAM', 'DAMU'] as const
const REPAYMENT_METHODS = [RepaymentMethods.ANNUITY, RepaymentMethods.EQUAL_INSTALMENTS]

const getProgramName = (code: ApplicationProgramCode) =>
  ({
    OWN_PROGRAM: 'Freedom Bank',
    DAMU: 'DAMU'
  }[code])

const dummySchema = yup.object({})

const createCalculatorSchema = ({
  minAmount,
  maxAmount,
  minPeriod,
  maxPeriod
}: {
  minAmount: number
  maxAmount: number
  minPeriod: number
  maxPeriod: number
}) => {
  return yup.object({
    amount: yup
      .string()
      .test(
        'min-amount',
        i18n.t('calculator-section.min-amount', { ns: 'landing', minAmount: numberWithSpaces(minAmount) }) as string,
        value => Number(value) >= minAmount
      )
      .test(
        'max-amount',
        i18n.t('calculator-section.max-amount', { ns: 'landing', maxAmount: numberWithSpaces(maxAmount) }) as string,
        value => Number(value) <= maxAmount
      )
      .required(i18n.language === 'ru' ? 'Заполните это поле, пожалуйста' : 'Осы өрісті толтырыңыз'),
    period: yup
      .string()
      .test(
        'min-amount',
        i18n.t('calculator-section.min-period', { ns: 'landing', minPeriod }) as string,
        value => Number(value) >= minPeriod
      )
      .test(
        'max-amount',
        i18n.t('calculator-section.max-period', { ns: 'landing', maxPeriod }) as string,
        value => Number(value) <= maxPeriod
      )
      .required(i18n.language === 'ru' ? 'Заполните это поле, пожалуйста' : 'Осы өрісті толтырыңыз')
  })
}

type CalculatorSchemaValues = yup.InferType<ReturnType<typeof createCalculatorSchema>>

export {
  type CalculatorSchemaValues,
  createCalculatorSchema,
  dummySchema,
  getProgramName,
  PROGRAM_CODES,
  REPAYMENT_METHODS
}
